import type { Static } from 'runtypes';
import { Literal, Record, String, Number } from 'runtypes';
import { CoreEventRuntype } from './core';
import { type BaseEvent, BaseEventRuntype } from './base';
import { ClickstreamEventEnum } from 'bc-model';

const AiShorthandFailedEventBrowserRuntype = BaseEventRuntype.And(
  Record({
    event: Literal(ClickstreamEventEnum.AI_SHORTHAND_FAILED),
    nodeId: Number,
    originalText: String,
    version: Literal(1),
  })
);

const AiShorthandFailedEventServerRuntype = AiShorthandFailedEventBrowserRuntype.And(
  CoreEventRuntype
).And(
  Record({
    sessionId: String,
  })
);

type AiShorthandFailedBrowserEvent = Static<typeof AiShorthandFailedEventBrowserRuntype>;
type AiShorthandFailedServerEvent = Static<typeof AiShorthandFailedEventServerRuntype>;

const isAiShorthandFailedBrowserEvent = (obj: BaseEvent): obj is AiShorthandFailedBrowserEvent => {
  return obj.event === 'AI Shorthand Failed';
};

const isAiShorthandFailedServerEvent = (obj: BaseEvent): obj is AiShorthandFailedServerEvent => {
  return obj.event === 'AI Shorthand Failed';
};

export {
  isAiShorthandFailedBrowserEvent,
  isAiShorthandFailedServerEvent,
  AiShorthandFailedEventBrowserRuntype,
  AiShorthandFailedEventServerRuntype,
  type AiShorthandFailedBrowserEvent,
  type AiShorthandFailedServerEvent,
};
